var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import cs from 'classnames';
import { Box } from 'ui-kit/box';
import styles from './modal-footer.module.scss';
export var ModalFooter = function (_a) {
    var display = _a.display, alignItems = _a.alignItems, children = _a.children, className = _a.className, gap = _a.gap, rest = __rest(_a, ["display", "alignItems", "children", "className", "gap"]);
    return (_jsx(Box, __assign({ className: cs(styles.modalFooter, className), display: display !== null && display !== void 0 ? display : 'flex', gap: gap !== null && gap !== void 0 ? gap : 8, alignItems: alignItems !== null && alignItems !== void 0 ? alignItems : 'center' }, rest, { children: children })));
};
